import type { Pinia } from 'pinia'
import { useModalStore } from '@shared/model'
import { useCartStore } from '@entities/order'
import { useRouter, useRoute } from '#imports'

const canRouterGoBack = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const state = window.history.state as { back?: string | null } | null
  return Boolean(state?.back)
}

export const useSystemBackAction = (pinia?: Pinia) => {
  const router = useRouter()
  const route = useRoute()
  const modalStore = useModalStore(pinia)
  const cartStore = useCartStore(pinia)

  const closeModalIfNeeded = () => {
    if (!modalStore.isOpen) {
      return false
    }

    modalStore.close()
    return true
  }

  const closeBasketIfNeeded = () => {
    if (!cartStore.isBasketOpen) {
      return false
    }

    cartStore.closeBasket()
    return true
  }

  const navigateBack = () => {
    if (canRouterGoBack()) {
      router.back()
      return true
    }

    if (route.path !== '/') {
      router.replace('/')
      return true
    }

    return false
  }

  const handleSystemBackAction = () => {
    if (closeModalIfNeeded()) {
      return true
    }

    if (closeBasketIfNeeded()) {
      return true
    }

    return navigateBack()
  }

  return {
    handleSystemBackAction,
  }
}

